import React from 'react'
import './switch-bed.less'
import { List, Toast, PullToRefresh, Result } from 'antd-mobile'
import ReactDOM from 'react-dom'
import { setHeader } from '@/util/set-header'
import { changeBedListApi } from '@/api/bed'

const APullToRefresh: any = PullToRefresh
const Item = List.Item
const Brief = Item.Brief

const ExtraCom = ({ item_id, currentId }: any) => {
  if (item_id === currentId) {
    return (
      <div className="checkin_room">
        <i className="iconfont font-8">&#xe677;</i>当前管理床位
      </div>
    )
  }
  return <div></div>
}
class SwitchBed extends React.Component<any, any> {
  el!: PullToRefresh

  constructor(props: any) {
    super(props)
    this.state = {
      list: [],
      checkin_id: '',
      noMoreData: false,
      height: (document.documentElement.clientHeight * 3) / 4,
    }
    // 获取app中checkin_id
    this.initList = this.initList.bind(this)
    this.onRefresh = this.onRefresh.bind(this)
    this.changeBed = this.changeBed.bind(this)
    this.leftClick = this.leftClick.bind(this)
    this.setPaymentInfo = this.setPaymentInfo.bind(this)
  }
  leftClick() {
    //返回App
    if (window.WebViewBridge) {
      window.WebViewBridge?.navBackMarket?.call(window.WebViewBridge)
    } else if (window.webkit) {
      window.webkit.messageHandlers.navBackMarket.postMessage('')
    }
  }
  setPaymentInfo = (argument: any) => {
    let checkin_id = ''
    if (typeof (argument) === 'string') {
      checkin_id = JSON.parse(argument).checkin_id
    } else {
      checkin_id = argument['checkin_id']
    }
    this.setState({
      checkin_id,
    })
  }

  UNSAFE_componentWillMount() {
    window.setPaymentInfo = this.setPaymentInfo
    if (window.WebViewBridge) {
      window.WebViewBridge?.userInfo?.call(window.WebViewBridge, 'setPaymentInfo')
    } else if (window.webkit) {
      window.webkit.messageHandlers.userInfo.postMessage('setPaymentInfo')
    }
    setHeader({ title: '床位选择', leftClick: this.leftClick })
  }
  //下拉刷新
  async onRefresh() {
    this.setState({ refreshing: true })
    await this.initList()
    this.setState({ refreshing: false })
  }
  componentDidMount() {
    const height =
      document.documentElement.clientHeight -
      (ReactDOM.findDOMNode(this.el) as any).getBoundingClientRect().top

    this.setState({
      height,
    })
    //获取床位列表
    this.initList()
  }
  async initList() {
    Toast.loading('加载中', 0)
    const { data } = await changeBedListApi()
    Toast.hide()
    if (data.code !== 'SUCCESS') {
      Toast.info(data.msg, 1)
      return
    }
    const list = data.data
    let noMoreData
    if (list && list.length > 0) {
      noMoreData = false
    } else {
      noMoreData = true
    }

    this.setState({
      list,
      noMoreData
    })
  }
  changeBed(item: any) {
    let arg = JSON.stringify(item)
    if (window.WebViewBridge) {
      window.WebViewBridge?.roomInfo?.call(window.WebViewBridge, arg)
    } else if (window.webkit) {
      window.webkit.messageHandlers.roomInfo.postMessage(arg)
    }
    if (window.WebViewBridge) {
      window.WebViewBridge?.navBackMarket?.call(window.WebViewBridge)
    } else if (window.webkit) {
      window.webkit.messageHandlers.navBackMarket.postMessage('')
    }
    // console.log("切换房间",arg)
  }
  render() {
    const { checkin_id, list, noMoreData } = this.state
    let bedItems
    if (list && list.length > 0) {
      bedItems = list.map((item: any, index: number) => (
        <Item
          key={index}
          extra={<ExtraCom item_id={item.checkin_id} currentId={checkin_id} />}
          onClick={() => {
            this.changeBed(item)
          }}
        >
          {item.text}
          <Brief>入住时间：{item.checkin_time}</Brief>
        </Item>
      ))
    }
    if (noMoreData) {
      bedItems = (
        <Result
          img={<img src="/public/assets/img/error.png" alt="" />}
          message={<div>您目前暂未入住</div>}
        />
      )
    }

    return (
      <div className="switch-bed">
        <APullToRefresh
          refreshing={this.state.refreshing}
          onRefresh={this.onRefresh}
          ref={(el: any) => (this.el = el)}
          style={{
            height: this.state.height,
            overflow: 'auto',
          }}
        >
          {bedItems}
        </APullToRefresh>
      </div>
    )
  }
}

export default SwitchBed
